<template>
  <section class="call-to-action"
           data-ivp-class="--animate"
           v-bind:style="`background-image:url(${require('@/assets/' + background + '')})`">
    <div class="overlay"></div>
    <div class="container">
      <p class="message"
         v-html="message">
      </p>
      <a v-bind:href="button_action"
         class="button"
         target="_blank"
         v-html="button_text">
      </a>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/cta.scss';
</style>

<script>

export default {
  name: 'cta',
  props: [
    'background',
    'message',
    'button_action',
    'button_text'
  ],
};
</script>